"use client";

import { ReactNode, useEffect } from "react";
import { initializeErrorTracking } from "@/lib/error-tracking";

interface ErrorTrackingProviderProps {
  children: ReactNode;
}

// ErrorBoundary is intentionally NOT used here — the app has a single
// route-aware ErrorBoundary (GlobalErrorBoundary) inside Providers that
// resets on navigation. A second frozen boundary here would intercept
// errors before they reach the resettable one, leaving the app stuck.
export const ErrorTrackingProvider = ({
  children,
}: ErrorTrackingProviderProps) => {
  useEffect(() => {
    initializeErrorTracking();
  }, []);

  return <>{children}</>;
};
